import React, { useState, useRef, useEffect } from "react";
import ConfirmationPopup from "../../../../popup/ConfirmationPopup";
import RenameModal from "./RenameModal";

export default function OwnSizeListComponant({
  sizeList,
  selectedListData,
  getSelectedListSizeData,
  createNewList,
  changedSizes,
  renameList,
  deleteList,
}) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [add, setAdd] = useState(false);
  const [delPopup, setDelPopup] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [renamePopup, setRenamePopup] = useState(false);
  const [renameData, setRenameData] = useState({});

  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div
       ref={wrapperRef}
        style={{ zIndex: "1"}}
        className="customSizeChart"
      >
        <button
          onClick={() => setOpen(!open)}
          style={{cursor: "pointer"}}
          className={`customSizeChartButton ${open ? 'menuOpen' : ''}`}
        >
          {sizeList.find((item) => item.id === selectedListData?.profile.id)
            ?.profile_name || "Default"}
          <span></span>
         
        </button>
        {open && (
          <div className="customSizeChartList">
            {sizeList &&
              sizeList.length > 0 &&
              sizeList.map((item) => (
                <div
                  key={item.id}
                  className="customSizeChartListItem"
                >
                  <div className="customSizeChartName">
                  <span 
                  className={
                    selectedListData?.profile.id === item.id ? "selectedOption" : ""
                  }
                      onClick={() => {
                        setRenamePopup(true);
                        setRenameData({
                          id: item.id,
                          name: item.profile_name,
                          isNew: item?.isNew,
                        });
                      }}
                    >{item?.profile_name}</span>
                  {/* {!item.is_default ? (
                    <img
                      src={"/assets/images/rename.png"}
                      alt="more icon"
                      title="Rename list"
                      style={{cursor:'pointer'}}
                    />
                  ):<span></span>} */}
                  <input
                    type="radio"
                    style={{cursor:"pointer"}}
                    title="Select List"
                    checked={selectedListData?.profile.id == item.id}
                    onChange={() => {
                      console.log("item.isNew is : ", selectedListData.isNew);
                      if (selectedListData.isNew && changedSizes.length > 0) {
                        alert(
                          "Please save the new list before selecting another list."
                        );
                        return;
                      }
                      getSelectedListSizeData(
                        item.id,
                        item.is_default || !item?.isNew ? "defaultt" : false,
                        "",
                        "onChange",
                        item.profile_name
                      );
                      setOpen(false);
                    }}
                  />
                  </div>
                  
                  {!item?.isNew && !item.is_default ? (
                    <span
                      onClick={() => {
                        setDeleteId(item.id);
                        setDelPopup(true);
                      }}
                      title="Delete List"
                      className="customSizeChartDelete"
                    >
                      <img
                        src={"/assets/images/delete-font-icn.svg"}
                        alt="Varient logo"
                        className="sidebar-logo-main"
                      />
                    </span>
                  ):<span></span>}
                </div>
              ))}
            {add && (
              <>
                <input
                  className="input-container"
                  placeholder="Enter new list name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <button
                  onClick={() => {
                    createNewList(name);
                    setTimeout(() => {
                      setAdd(false);
                    }, 500);
                  }}
                  className="customSizeChartAddButton"
                  // style={{width:"50px"}}
                >
                  Add
                </button>
              </>
            )}
            {!add && (
              <button
                onClick={() => setAdd(true)}
                className="customSizeChartAddButton"
              >
                Add New List
              </button>
            )}
          </div>
        )}
        {}
      </div>
      {delPopup && (
        <ConfirmationPopup
          heading={"Are you sure you want to delete this list?"}
          close={() => setDelPopup(false)}
          yesDoIt={() => {
            deleteList(deleteId);
            setDelPopup(false);
          }}
        />
      )}
      {renamePopup && (
        <RenameModal
          close={() => setRenamePopup(false)}
          renameList={renameList}
          data={renameData}
        />
      )}
    </>
  );
}
